module.exports = __webpack_public_path__ + "img/co-branding-logo-burger-king.e6fb63c0.png";